import { NotificationManager } from 'react-notifications';
import { Link, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import accounting from 'accounting';
import _ from 'lodash';

import { getTransactionDetails, limpiarCarrito } from '../actions';

class DetalleCompra extends Component {

  componentDidMount(){
    if (this.props.match.params.idcompra===undefined) {
      NotificationManager.error("No se ha especificado el id de la compra");
    }else{
      this.props.getTransactionDetails(this.props.match.params.idcompra);
    }
  }

  renderLista(){
    let productos = _.map(this.props.buyDetail.cursos, (pro, key)=>{
      return (
        <tr key={pro.id}>
          <th scope="row">{pro.id}</th>
          <td>{pro.nombre}</td>
          <td className="cost">{accounting.formatMoney(pro.costo, "Gs", 0, ".")}.-</td>
        </tr>
      );
    });
    return (
      <tbody>
        {productos}
      </tbody>
    );
  }

  renderFooter(){
    let total = 0;
    _.mapValues(this.props.buyDetail.cursos, (pro)=>{
      total += parseInt(pro.costo, 10);
    })
    return (
      <thead className="thead-light">
        <tr>
          <th scope="col" colSpan="2" >Total</th>
          <th scope="col" className="cost">{accounting.formatMoney(total, "Gs", 0, ".")}.-</th>
        </tr>
      </thead>
    );
  }



  render(){
    if(this.props.buyDetail===null){
      return (
        <div id="detalle_compra">
          <div className="container">
            <h1>Cargando...</h1>
          </div>
        </div>
      );
    }
    if(this.props.buyDetail.error !== undefined){
      return (
        <div id="detalle_compra">
          <div className="container">
            <h1>Un error ha ocurrido durante la transacción.</h1>
            <p>Error: {this.props.buyDetail.error}</p>
            <div className="btn-group float-right" role="group">
              <Link
                to="/"
                className="btn btn-secondary" >
                  Inicio
              </Link>
            </div>
          </div>
        </div>
      );
    }
    if(Object.keys(this.props.buyDetail.cursos).length<=0){
      NotificationManager.warning("Su carrito está vacío, será redirigido a la pantalla de inicio", "Carrito Vacío", 5000);
      return <Redirect push to="/cursos/1" />;
    }
    //se vacía el carrito
    this.props.limpiarCarrito();
    //se devuelve el detalle de la compra
    return (
      <div id="detalle_compra">
        <div className="container" >
          <h1>Detalle de Compra</h1>

          <hr />

          <div className="card">
            <div className="card-header">
              Detalles de La Transacción
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><b>Número de Transacción:</b> {this.props.buyDetail.id}</li>
              <li className="list-group-item"><b>Fecha:</b> {this.props.buyDetail.fecha}</li>
              <li className="list-group-item"><b>Hora:</b> {this.props.buyDetail.hora}</li>
              <li className="list-group-item"><b>Nombre:</b> {this.props.buyDetail.nombre}</li>
              <li className="list-group-item"><b>Respuesta de la Transacción:</b> {this.props.buyDetail.response_description}</li>
            </ul>
          </div>

          <hr />

          <h3>Cursos Comprados</h3>
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">COD</th>
                <th scope="col">Descripción</th>
                <th scope="col" className="cost">Costo</th>
              </tr>
            </thead>
            {this.renderLista()}
            {this.renderFooter()}
          </table>
          <div className="btn-group float-right" role="group">
            <Link
              to="/"
              className="btn btn-secondary" >
                Inicio
            </Link>
            <Link
              to="/mis-cursos"
              className="btn btn-primary" >
                Mis cursos
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ buyDetail }) {
  return { buyDetail };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    limpiarCarrito,
    getTransactionDetails
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DetalleCompra);



// WEBPACK FOOTER //
// ./src/containers/detalle_compra.js